




























import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { Variant, VariantType } from '~/models/app/variant'
import { Size } from '~/models/app/size'

export default defineComponent({
  props: {
    ping: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String as PropType<VariantType>,
      default: null
    },
    size: {
      type: String as PropType<Size>,
      default: Size.MD
    }
  },
  setup(props) {
    const { variant, size } = toRefs(props)

    const variantIsInfo = computed(() => variant.value === Variant.INFO)
    const variantIsSuccess = computed(() => variant.value === Variant.SUCCESS)
    const variantIsDanger = computed(() => variant.value === Variant.DANGER)

    const circleStateClass = computed(() => {
      if (variantIsInfo.value) {
        return ['tw-bg-blue-100']
      } else if (variantIsSuccess.value) {
        return ['tw-bg-green-100']
      } else if (variantIsDanger.value) {
        return ['tw-bg-red-100']
      }
      return ['tw-bg-grey-200']
    })

    const pingClasses = computed(() => {
      if (variantIsInfo.value) {
        return ['tw-bg-blue-300']
      } else if (variantIsSuccess.value) {
        return ['tw-bg-green-300']
      } else if (variantIsDanger.value) {
        return ['tw-bg-red-300']
      }
      return ['tw-bg-grey-300']
    })

    const sizeClasses = computed(() => {
      if (size.value === Size.SM) {
        return ['tw-h-4 tw-w-4']
      }
      return ['tw-h-5 tw-w-5']
    })

    return {
      variantIsInfo,
      variantIsSuccess,
      variantIsDanger,
      faCheck,
      faTimes,
      circleStateClass,
      pingClasses,
      sizeClasses
    }
  }
})
